import '@babel/polyfill'

// if (!Element.prototype.matches) {
//     Element.prototype.matches =
//         Element.prototype.matchesSelector ||
//         Element.prototype.mozMatchesSelector ||
//         Element.prototype.msMatchesSelector ||
//         Element.prototype.oMatchesSelector ||
//         Element.prototype.webkitMatchesSelector ||
//         function (s) {
//             var matches = (this.document || this.ownerDocument).querySelectorAll(s),
//                 i = matches.length;
//             while (--i >= 0 && matches.item(i) !== this) {}
//             return i > -1;
//         };
// }

// (function (arr) {
//     arr.forEach(function (item) {
//         if (item.hasOwnProperty('before')) {
//             return;
//         }
//         Object.defineProperty(item, 'before', {
//             configurable: true,
//             enumerable: true,
//             writable: true,
//             value: function before() {
//                 var argArr = Array.prototype.slice.call(arguments),
//                     docFrag = document.createDocumentFragment();

//                 argArr.forEach(function (argItem) {
//                     var isNode = argItem instanceof Node;
//                     docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
//                 });

//                 this.parentNode.insertBefore(docFrag, this);
//             }
//         });
//     });
// })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS

//////////////////////////////////////////////////////////////// Cookies Message
// import VueCookies from 'vue-cookies'
// Vue.use(VueCookies)

//////////////////////////////////////////////////////////////// Collapse (Accordion)
// import {
//     CollapsePlugin
// } from 'bootstrap-vue'
// Vue.use(CollapsePlugin)

//////////////////////////////////////////////////////////////// Fixed element on scroll
// import Affix from 'vue-affix'
// Vue.use(Affix)

//////////////////////////////////////////////////////////////// Scroll To
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    container: "body",
    duration: 750,
    easing: "ease",
    offset: -120,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

//////////////////////////////////////////////////////////////// Bootstrap Modal
import {
    ModalPlugin
} from 'bootstrap-vue'
Vue.use(ModalPlugin)

//////////////////////////////////////////////////////////////// Bootstrap Tabs
// import {
//     TabsPlugin
// } from 'bootstrap-vue'
// Vue.use(TabsPlugin)

//////////////////////////////////////////////////////////////// Form validation
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS

//////////////////////////////////////////////////////////////// Background Image
import BgImage from './components/bg-image/bg-image.vue'
Vue.component('bgImage', BgImage)

//////////////////////////////////////////////////////////////// Select Dropdown
// import vSelect from 'vue-select'
// Vue.component('vSelect', vSelect)
// vSelect.props.components.default = () => ({
//     Deselect: {
//         render: createElement => createElement(''),
//     },
//     OpenIndicator: {
//         render: createElement => createElement('i', {
//             class: {
//                 'icon-arrow-light-down icon-sm': true
//             }
//         }),
//     },
// });

/////////////////////////////////////////////////////////////////////////////////////////////////// DIRECTIVES

//////////////////////////////////////////////////////////////// Gallery Lightbox
// import FancyBox from './directives/fancy-box'
// Vue.directive('fancy-box', FancyBox)

//////////////////////////////////////////////////////////////// Scrollbar
// import Vuebar from 'vuebar'
// Vue.directive('vuebar', Vuebar)

//////////////////////////////////////////////////////////////// Scroll Magic
import ScrollMagic from './directives/scroll-magic/index.js'
Vue.directive('scroll-magic', ScrollMagic)

//////////////////////////////////////////////////////////////// Gsap
import Gsap from './directives/gsap/index.js'
Vue.directive('gsap', Gsap)

/////////////////////////////////////////////////////////////////////////////////////////////////// APP

//////////////////////////////////////////////////////////////// Bit.dev
import CookiesMsg from './components/cookies-msg/index.vue'
import SideMenu from './components/side-menu/side-menu.vue'

//////////////////////////////////////////////////////////////// Local
// import ExpertiseTabs from './expertise-tabs.js'
import ViewPublications from './view-publications.js'
import ContactForm from './contact-form.js'
import GoogleMap from './google-map.vue'

import {
    devices
} from './imports/utils'

var app = new Vue({
    el: '#app',
    components: {
        CookiesMsg,
        SideMenu,
        // ExpertiseTabs,
        ViewPublications,
        ContactForm,
        GoogleMap
    },
    data() {
        return {
            lang: document.getElementById('app').getAttribute('lang'),
            isDevice: devices(),
            pageScrolled: false,
            sideMenuOpen: false,
            windowWidth: window.innerWidth,
        }
    },
    methods: {
        onScroll() {
            this.pageScrolled = window.pageYOffset > 0
        },
        onResize() {
            this.windowWidth = window.innerWidth
        },
    },
    created() {
        this.pageScrolled = window.pageYOffset > 0;

        window.addEventListener('scroll', this.onScroll, {
            passive: true
        })

        window.addEventListener("resize", this.onResize, {
            passive: false
        });

        console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;');
    },
    mounted() {},
    destroyed() {
        window.removeEventListener('scroll', this.onScroll)

        window.removeEventListener("resize", this.onResize)
    }
})